import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { categoryMaster } from 'src/app/Models/BasicForms/categoryMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-category-drawer',
  templateUrl: './category-drawer.component.html',
  styleUrls: ['./category-drawer.component.css']
})
export class CategoryDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: categoryMaster;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  ngOnInit(): void { }

  close(categoryPage: NgForm) {
    this.drawerClose();
    this.reset(categoryPage);
  }

  reset(categoryPage: NgForm) {
    this.isSpinning = false;
    categoryPage.form.reset();
    this.data = new categoryMaster();
  }

  isSpinning = false;
  logtext: string = "";
  save(addNew: boolean): void {
    var isOk = true;

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Category Name", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Category Name", "");
    }

    if (this.data.IS_ACTIVE == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Category is Active or Not", "");
    }

    if (isOk) {
      this.isSpinning = true;

      if (!this.data.ID) {
        this._apiService.createCategory(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Category Added Successfully", "");

            if (!addNew) {
              this.drawerClose();
              this.isSpinning = false;

              this.logtext = 'Save & Close - Category Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Category Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new categoryMaster();

              this.logtext = 'Save & New - Category Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Category Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Category", "");
            this.logtext = 'Save & Close - Category Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Category Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {

        this._apiService.updateCategory(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Category Updated Successfully", "");
            this.logtext = 'Update & Close - Category Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Category Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Category", "");
            this.logtext = 'Update & Close - Category Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Category Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }
}
